var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { footer } from '../utils/theme';
import { registerClass, subClass } from '@food/css-manager';
import { Button } from '@food/ui/build/dist/src/Button';
var style = registerClass(function (theme, sc) { return "\n\tpadding-top: " + theme.ratios.l * theme.font.baseSize + "px;\n\tpadding-bottom: " + theme.ratios.l * theme.font.baseSize + "px;\n\t\n\t." + sc('role') + " {\n\t\tmargin-top: " + theme.ratios.s * theme.font.baseSize + "px;\n\t}\n"; });
/**
 * Componente utilizzato per mostrare un messaggio all'utente consumer che desidera fare l'upgrade di ruolo
 */
export var ChooseUpgradeRole = function (_a) {
    var t = _a.t, upgrade = _a.upgrade, close = _a.close;
    var intro = t('upgrade role introduction html');
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Upgrade role"], ["Upgrade role"])))),
        React.createElement("section", { className: style },
            intro !== '' && (React.createElement("div", { dangerouslySetInnerHTML: { __html: intro } })),
            React.createElement(Button, { label: t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Upgrade to Professional"], ["Upgrade to Professional"]))), onClick: upgrade, block: true, className: subClass(style, 'role'), type: 'success' }),
            React.createElement("div", { className: footer },
                React.createElement(Button, { label: t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Close"], ["Close"]))), onClick: function () { return close(); } })))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ChooseUpgradeRole.js.map